var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-box"},[_c('img',{staticClass:"pdf-cover",attrs:{"src":require("../assets/capa_livro_padrao.jpeg"),"alt":"Capa do PDF"}}),_c('div',{staticClass:"pdf-info"},[_c('span',{staticClass:"pdf-title"},[_vm._v(_vm._s(_vm.discipline.nome_disciplina))]),_c('div',{staticClass:"btn-class"},[_c('router-link',{staticClass:"pdf-link",attrs:{"to":{
                    path: '/classes',
                    query: { discipline: _vm.discipline.codigo_disciplina }
                }}},[_vm._v(" Ver disciplina ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }